module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/personal-care-man-banner_18f695.png";